// Hide resident stories section if it's empty

(function ($, Drupal) {

  Drupal.behaviors.residentStories = {

    attach: function (context, settings) {

      const $residentStoriesSection = $('.resident-stories__reviews');
      const $reviewsSection = $('.tg-review-widget-container');
      const $careRatingSection = $('.care_rating');
      const $careQualitySection = $('.care_quality');

      // Check if each section has children - if none of them do then the section is empty
      if ( $reviewsSection.children().length === 0 && $careRatingSection.children().length === 0 && $careQualitySection.children().length === 0 ) {
        $residentStoriesSection.css('display', 'none');
      }

    }
  };
})(jQuery, Drupal);
